/**
 * plot-comparison
 */

import $ from 'jquery';
import dragscroll from 'dragscroll';

// Module dependencies
import 'protons';

// Module template
import './_plot-comparison.twig';
import './_plot-comparison.css';

export const name = 'plot-comparison';

export const defaults = {
  dummyClass: 'js-plot-comparison-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { plotComparison = {} }) {
  // Find our component within the DOM
  // eslint-disable-next-line no-undef
  const plotComparisonDropDowns = once(
    'plot-comparison--init',
    '.plot-comparison__dropdown',
    $context
  );

  // Bail if component does not exist
  if (!plotComparisonDropDowns.length) {
    return;
  }

  const $plotComparisonDropDown = $(plotComparisonDropDowns);

  // Dropdown selector for interactions.
  const $plotComparison = $plotComparisonDropDown.parents('.plot-comparison');
  $('.plot-comparison__media', $plotComparison).addClass('dragscroll');

  // Merge defaults with incoming settings.
  const settings = {
    ...defaults,
    ...plotComparison,
  };
  // An example of what could be done with this component
  $plotComparison.addClass(settings.dummyClass);

  $plotComparisonDropDown.change(function dropdownChangeHandler() {
    const val = $(this).val();
    const cloned = $(this)
      .parents('.plot-comparison')
      .find(`[data-photo-id="${val}"]`)
      .eq(0)
      .clone();
    $(this)
      .parents('.plot-comparison__area')
      .find('.plot-comparison__viewport')
      .empty()
      .append(cloned);

    // Adds dragscroll on desktop.
    if (window.innerWidth >= 992) {
      cloned.find('.plot-comparison__media').addClass('dragscroll');
    }
    dragscroll.reset();
  });

  // If there is only one option, picks it for both.
  Object.keys($plotComparisonDropDown).forEach(($dropdown, index) => {
    if (index % 2 === 0) {
      if ($plotComparisonDropDown.eq(index).children().length === 1) {
        $plotComparisonDropDown.eq(index).val('');
      } else {
        const val1 = $plotComparisonDropDown
          .eq(index)
          .find('option:nth-child(2)')
          .val();
        const val2 = $plotComparisonDropDown
          .eq(index)
          .find('option:nth-child(3)')
          .val();
        $plotComparisonDropDown.eq(index).val(val1);
        $plotComparisonDropDown.eq(index + 1).val(val2);
      }
      $plotComparisonDropDown.eq(index).trigger('change');
      $plotComparisonDropDown.eq(index + 1).trigger('change');
    }
  });
  $plotComparison
    .find('.plot-comparison__range')
    .on('input', function zoomHandler() {
      const value = $(this).val();
      const img = $(this)
        .parents('.plot-comparison__viewport-area')
        .find('.plot-comparison__viewport img');
      if (value === 100) {
        img.addClass('zoom').css('width', '');
      } else {
        img.addClass('zoom').css('width', `${value}%`);
      }
    });
}

export default enable;
